import React from 'react';
import { User, Scale, Ruler } from 'lucide-react';

/**
 * Компонент с базовыми параметрами для расчета процента жира
 */
const BasicParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  activityLevels
}) => {
  return (
    <div className="mb-6">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">
        Базовые параметры
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Пол */}
        <div className="col-span-full">
          <div className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Пол
          </div>
          <div className="grid grid-cols-2 gap-3">
            <label className="flex items-center justify-center p-3 border rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors
              ${formData.gender === 'male' 
                ? 'border-emerald-300 bg-emerald-50 dark:border-emerald-700 dark:bg-emerald-900/20'
                : 'border-gray-200 dark:border-gray-700'
              }"
            >
              <input
                type="radio"
                name="gender"
                value="male"
                checked={formData.gender === 'male'}
                onChange={handleInputChange}
                className="form-radio sr-only"
              />
              <User className="w-5 h-5 mr-2 text-blue-500" />
              <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                Мужской
              </span>
            </label>
            <label className="flex items-center justify-center p-3 border rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors
              ${formData.gender === 'female' 
                ? 'border-emerald-300 bg-emerald-50 dark:border-emerald-700 dark:bg-emerald-900/20'
                : 'border-gray-200 dark:border-gray-700'
              }"
            >
              <input
                type="radio"
                name="gender"
                value="female"
                checked={formData.gender === 'female'}
                onChange={handleInputChange}
                className="form-radio sr-only"
              />
              <User className="w-5 h-5 mr-2 text-pink-500" />
              <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                Женский
              </span>
            </label>
          </div>
        </div>
        
        {/* Возраст */}
        <div>
          <label htmlFor="age" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Возраст (лет)
          </label>
          <input
            type="number"
            id="age"
            name="age"
            value={formData.age}
            onChange={handleInputChange}
            min="18"
            max="100"
            className={`form-input w-full ${errors.age ? 'input-error' : ''}`}
            placeholder="Например: 30"
          />
          {errors.age && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">{errors.age}</p>
          )}
        </div>
        
        {/* Вес */}
        <div>
          <label htmlFor="weight" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Scale className="w-4 h-4 mr-2 text-emerald-500" />
            Вес (кг)
          </label>
          <input
            type="number"
            id="weight"
            name="weight"
            value={formData.weight}
            onChange={handleInputChange}
            min="30"
            max="300"
            step="0.1"
            className={`form-input w-full ${errors.weight ? 'input-error' : ''}`}
            placeholder="Например: 75"
          />
          {errors.weight && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">{errors.weight}</p>
          )}
        </div>
        
        {/* Рост */}
        <div>
          <label htmlFor="height" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Ruler className="w-4 h-4 mr-2 text-emerald-500" />
            Рост (см)
          </label>
          <input
            type="number"
            id="height"
            name="height"
            value={formData.height}
            onChange={handleInputChange}
            min="100"
            max="250"
            className={`form-input w-full ${errors.height ? 'input-error' : ''}`}
            placeholder="Например: 175"
          />
          {errors.height && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">{errors.height}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default BasicParametersSection;